export enum EventTypeEnum {
  SIMPLE = 'SIMPLE',
  DERIVED = 'DERIVED',
  AV = 'AV',
}
